export default [{
  name: 'nav.home',
  to: { name: 'index' }
}, {
  name: 'nav.works',
  to: { name: 'work.list' }
}, {
  name: 'nav.about',
  to: { name: 'about' }
}, {
  name: 'nav.business',
  to: { name: 'business' }
}, {
  name: 'nav.service',
  to: { name: 'service' }
}, {
  name: 'nav.contact',
  to: { name: 'contact' }
}];



// WEBPACK FOOTER //
// ./src/navConfig.js